import { useState } from "react";

import { Box, ButtonBase, Popover, Tooltip, Typography } from "@mui/material";

import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import { useSucursalOperativa } from "../context/SucursalOperativaContext";

export default function SucursalSwitcher() {
  const { sucursales, sucursalActual, seleccionar } = useSucursalOperativa();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!sucursalActual) return null;

  const open = Boolean(anchorEl);

  const handleSelect = (id) => {
    seleccionar(id);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Cambiar sucursal">
        <ButtonBase
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.35,
            px: 0.35,
            py: 0.15,
            borderRadius: 0.8,
            color: "text.secondary",
            transition: "all .15s ease",
            "&:hover": {
              color: "text.primary",
              backgroundColor: "rgba(255,255,255,0.045)",
            },
          }}
        >
          <StorefrontRoundedIcon
            sx={{
              fontSize: 12,
            }}
          />

          <Typography
            sx={{
              fontSize: 10.8,
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {sucursalActual.nombre}
          </Typography>

          <KeyboardArrowDownRoundedIcon
            sx={{
              fontSize: 12.5,
            }}
          />
        </ButtonBase>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              mb: 0.45,

              minWidth: 116,

              p: 0.35,

              borderRadius: 1.4,

              backgroundImage: "none",

              backgroundColor:
                theme.palette.background.sidenav ||
                theme.palette.background.paper,

              border: "1px solid",
              borderColor:
                theme.palette.mode === "dark"
                  ? "rgba(255,255,255,0.09)"
                  : "rgba(0,0,0,0.08)",

              boxShadow:
                theme.palette.mode === "dark"
                  ? "0 6px 16px rgba(0,0,0,0.38)"
                  : "0 6px 16px rgba(0,0,0,0.12)",

              overflow: "visible",

              "&::after": {
                content: '""',
                position: "absolute",

                left: 18,
                bottom: -4,

                width: 7,
                height: 7,

                transform: "rotate(45deg)",

                backgroundColor:
                  theme.palette.background.sidenav ||
                  theme.palette.background.paper,

                borderRight: "1px solid",
                borderBottom: "1px solid",

                borderColor:
                  theme.palette.mode === "dark"
                    ? "rgba(255,255,255,0.09)"
                    : "rgba(0,0,0,0.08)",
              },
            }),
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.15,
          }}
        >
          {sucursales.map((s) => {
            const selected = s.id === sucursalActual.id;

            return (
              <ButtonBase
                key={s.id}
                onClick={() => handleSelect(s.id)}
                sx={(theme) => ({
                  width: "100%",

                  minHeight: 27,

                  px: 0.65,
                  py: 0.25,

                  borderRadius: 0.9,

                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",

                  gap: 0.5,

                  color: selected ? "warning.main" : "text.primary",

                  backgroundColor: selected
                    ? theme.palette.mode === "dark"
                      ? "rgba(255,145,0,0.09)"
                      : "rgba(255,145,0,0.07)"
                    : "transparent",

                  transition: "background-color .12s ease",

                  "&:hover": {
                    backgroundColor: selected
                      ? theme.palette.mode === "dark"
                        ? "rgba(255,145,0,0.13)"
                        : "rgba(255,145,0,0.10)"
                      : "rgba(255,255,255,0.045)",
                  },
                })}
              >
                <Box
                  sx={{
                    width: 14,
                    height: 14,

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    flexShrink: 0,
                  }}
                >
                  {selected && (
                    <CheckRoundedIcon
                      sx={{
                        fontSize: 13.5,
                      }}
                    />
                  )}
                </Box>

                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: selected ? 700 : 500,
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  {s.nombre}
                </Typography>
              </ButtonBase>
            );
          })}
        </Box>
      </Popover>
    </>
  );
}
